import { Component, EventEmitter, Input, OnChanges, Output, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { appService } from '../../../_services/app.service';
import { CommonService } from '../../../shared/services/commen/commen.services';
import { environment } from '../../../../environments/environment';
import { Http } from '@angular/http';
import { ToastrService } from 'ngx-toastr';
import { NetworkDetailsByIdEditComponent } from '../../../new-network/network-details-by-id/network-details-by-id-edit/network-details-by-id-edit.component';
import { Helpers } from '../../../helpers';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { CookieService } from 'ngx-cookie-service';


@Component({
  selector: 'app-new-registration-upload',
  templateUrl: './new-registration-upload.component.html',
  styleUrls: ['./new-registration-upload.component.scss']
})
export class NewRegistrationUploadComponent implements OnInit {

  @Input() data: any;
  @Input() networkId: any;
  @Input() isRegistrationSave: any;
  @Input() OtherDetails: any = {};
  @Output() modifiedValueOutput = new EventEmitter<any>()
  @Output() onFileSelect = new EventEmitter<any>();
  @Output() onFileDelete = new EventEmitter<any>();
  @Input() country: any;
  @Output() saveTaxData = new EventEmitter<any>();//added by BURHAN - 28-April-2026
  @Output() registrationSaved = new EventEmitter<any>();//added by BURHAN - 5-May-2026
  Label: any;
  Number: any;
  IsForLifeTime: any;
  FileName: any;
  Validity: any;

  registrationObj: any = {};

  listOfFile: any[];
  registerarray: any[] = [];

  isdatedisable: boolean;
  ExportType: any;
  isUnRegistered : boolean;//added by BURHAN - 29-April-2026
  UserId: any;

  @Input() isBranchData: boolean=false;

  constructor(
    private translate: TranslateService,
    private _appService: appService,
    private commonService: CommonService,
    private anghttp: Http,
    private toastr: ToastrService,
    private decryptpipe: DecryptPipe,
    private cookieService: CookieService,
  ) { }

  ngOnInit() {
    this.UserId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    // this.initializeform();
    this.GetRegister();
    this.GetTaxPreference();
    // if (!this.registerarray || this.registerarray.length === 0) {
    //   this.GetRegistrationData();
    // }
    //this.GetRegistrationData();
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.country && changes.country.currentValue) {
    // Agar registerarray empty hai tabhi templates lao
    // if (!this.registerarray || this.registerarray.length === 0) {
    //   this.GetRegistrationData();
    // }
      this.GetRegistrationData();
  }
    //added by BURHAN - 29-April-2026
    if (changes.OtherDetails && changes.OtherDetails.currentValue) {
      this.isUnRegistered = this.OtherDetails.isUnRegistered;

      const gst1Val = this.OtherDetails.GST1Number;
      if (gst1Val !== undefined) {
        const gst1Item = this.registerarray.find(
          item => item.Label === 'GST1 (15 digit)'
        );
        if (gst1Item && gst1Item.Number !== gst1Val) {
          gst1Item.Number = gst1Val;
          gst1Item['Number'] = gst1Val;
          this.registerarray = [...this.registerarray];
        }
      }
    }
    //end by BURHAN - 29-April-2026
  }
  listOfField = []

  // initializeform() {
  //   this.FileName={
  //       Label:"File Name",
  //       dataField:"FileName",
  //       formControlName: 'FileName',
  //   };
  //   this.Number={
  //       Label:"Number",
  //       dataField:"Number",
  //       formControlName: 'Number',
  //   };
  //   this.IsForLifeTime= {
  //         lable: "Is Default",
  //         dataField: 'IsDefaultNew',
  //   };
  //   this.Validity={
  //       lable: "Date",
  //         placeholder: "Select date",
  //         dataField: 'Validity',
  //         formControlName: 'Validity',
  //   };
  // }

  getChangedValue(value, dataFeild, item) {

    item[dataFeild] = value;
    if (dataFeild == "IsForLifeTime") {
      this.isdatedisable = value;
    }
    //added by BURHAN - 29-April-2026
    if (item.Label === 'GST1 (15 digit)' && dataFeild === 'Number') {
      this.modifiedValueOutput.emit({ value, dataFeild: 'GST1Number' });
    }
  //end by BURHAN
    const filteredData = this.registerarray.map(item => {
      const { FileNameObj, NumberObj, IsForLifeTimeObj, ValidityObj, ...filteredItem } = item;
      return filteredItem;
    });
  }


  onFileDeleteFn(selectedFile) {
    this.onFileDelete.emit(selectedFile);
  }

  getFilePreview(item) {
    if (item.documentpath && item.documentpath !== "." && item.filename) {

      const fullFileName = item.filepath || "";
      const displayFileName = fullFileName.includes("_")
        ? fullFileName.split("_").pop()
        : fullFileName;

      return [{ name: item.filename, url: item.filepath }];
    } else {

      return [];
    }
  }


  GetRegister() {
    this._appService.GetById("Network", "GetRegisteredDocss", this.networkId).subscribe(
      (res) => {
        if (res && Array.isArray(res) && res.length > 0) {
          this.registerarray = res.map((item) => {
            const fullFileName = item.FileName || "";
            const displayFileName = fullFileName.includes("_") ? fullFileName.split("_").pop() : fullFileName;
            const filepath = environment.apiUrl + item.DocumentPath;

            return {
              ...item,
              FileNameObj: {
                Label: "File Name",
                dataField: "FileName",
                formControlName: "FileName",
                documentpath: item.DocumentPath,
                filepath: filepath,
                filename: displayFileName,
              },
              NumberObj: {
                Label: "Number",
                dataField: "Number",
                formControlName: "Number",
                placeholder: "Enter number",
              },
              IsForLifeTimeObj: {
                lable: "Is Default",
                dataField: "IsForLifeTime",
              },
              ValidityObj: {
                placeholder: "Select date",
                dataField: "Validity",
                formControlName: "Validity",
                isReadOnly: this.isdatedisable,
              },
            };
          });
        } else {
          this.registerarray = [];
        }

        // GST1 sync
        const gst1Val = this.OtherDetails.GST1Number;
        if (gst1Val !== undefined) {
          const gst1Item = this.registerarray.find(item => item.Label === 'GST1 (15 digit)');
          if (gst1Item) {
            gst1Item.Number = gst1Val;
            gst1Item['Number'] = gst1Val;
          }
        }

        // YAHAN CALL KAR DE - GetRegister complete hone ke baad
        this.GetRegistrationData();
      },
      (error) => {
        console.log("Error while Getting Register", error);
        // error aaye tab bhi templates load kar
        this.GetRegistrationData();
      }
    );
  }

  onFileSelectFn(event: any, data: any) {

    const selectedFile = event.target.files[0];
    const { formData, options } = this.commonService.setHeaderAndOptionsForFileUpload(selectedFile);
    const apiUrl =
      environment.apiUrl +
      "/api/Document/UploadAttachment?ReferenceId=" +
      this.networkId +
      "&TransectionType=" +
      data.Label +
      "&ParentId=" +
      null;
    const req1 = this.anghttp.post(apiUrl, formData, options).subscribe(
      (response) => {
        var uploadSuccess = this.translate.instant("Attachment.AttachmentUploadSuccess")
        this.toastr.success(
          uploadSuccess,
          "success"
        );
      },
      (err) => {
        var uploadError = this.translate.instant("Attachment.UploadError")
        this.toastr.error(uploadError, "error");
      }
    );
  }

  saveRegistrationData(): boolean {
  
  let taxPreference = '';
  if (this.OtherDetails && this.OtherDetails.TaxPreference) {
    taxPreference = this.OtherDetails.TaxPreference;
  }
  
  let isUnRegistered = false;
  if (this.OtherDetails && this.OtherDetails.isUnRegistered !== undefined) {
    isUnRegistered = this.OtherDetails.isUnRegistered;
  }
  //added by BURHAN - 6-May-2026
    //FIX 1: Pehle check karo GST1 mandatory hai ya nahi
    const isGST1Required = taxPreference === 'Taxable' && !isUnRegistered;

    const gst1Item = this.registerarray.find(
      item => item.Label === 'GST1 (15 digit)'
    );

    // FIX 2: Agar GST1 required hai to Registration array me hona chahiye
    if (isGST1Required) {
      if (!gst1Item) {
        this.toastr.error("GST1 (15 digit) is required when GST Registered!", "Error");
        return false;
      }

      // FIX 3: GST1 ka Number empty nahi hona chahiye
      if (!gst1Item.Number || gst1Item.Number.trim() === '') {
        this.toastr.error("GST1 (15 digit) number cannot be empty!", "Error");
        return false;
      }

      // FIX 4: Format check
      if (!this.CheckGSTCNO(gst1Item.Number, "after")) {
        return false;
      }
    }
    const gst1NumberFromTax = this.OtherDetails.GST1Number;
    //end by BURHAN
  // GST1 validation
  //comment by BURHAN -6-May-2026
  // const gst1Item = this.registerarray.find(
  //   item => item.Label === 'GST1 (15 digit)'
  // );

  // const gst1NumberFromTax = this.OtherDetails.GST1Number;
  //end by BURHAN - 6-May-2026
  // Agar GST1 item array me nahi hai but Tax tab me value hai, to temp item banao
  if (!gst1Item && gst1NumberFromTax && gst1NumberFromTax.trim() !== '') {
    if (!this.CheckGSTCNO(gst1NumberFromTax, "after")) {
      return false;
    }
    
    // Temp GST1 object add kar do
    this.registerarray.push({
      Label: 'GST1 (15 digit)',
      Number: gst1NumberFromTax,
      DocumentId: null, // agar naya hai to null
      CompanyId: this.networkId,
      IsNetworkCompany: this.isBranchData ? false : true
    });
  } else if (gst1Item && gst1Item.Number && gst1Item.Number.trim() !== '') {
    if (!this.CheckGSTCNO(gst1Item.Number, "after")) {
      return false;
    }
  }

  const filteredData = this.registerarray.map(item => {
    if(this.isBranchData){
      item.IsNetworkCompany = false;
    }else{
      item.IsNetworkCompany = true;
    }
    const { FileNameObj, NumberObj, IsForLifeTimeObj, ValidityObj, ...filteredItem } = item;
    return filteredItem;
  }).filter(item => item !== null);

  if (filteredData.length === 0) {
    this.toastr.warning("No registration data to save", "Warning");
    return true; // ya false kar do agar save nahi karna
  }

  this._appService
    .Post("Company", "SaveRegistration", filteredData)
    .subscribe(
      (response) => {
        this.toastr.success("Registration data saved Successfully !", "Success");
        this.GetRegister();
        this.registrationSaved.emit(true);
      },
      (err) => {
        this.toastr.error("Error occurred while saving Registration Data !", "error");
      }
    );

    return true;
}


  // saveRegistrationData() {

  //   const filteredData = this.registerarray.map(item => {
  //     item.IsNetworkCompany = true;

  //     // if export type is taxable and label is GST1 then number is required  
  //     if (this.OtherDetails.TaxPreference === 'Taxable' && item.Label === 'GST1 (15 digit)') {
  //       if (!item.Number || item.Number.trim() === '') {
  //         this.toastr.error("GST1 (15 digit) number is required!", "Error");
  //         return;
  //       } else {
  //         if (!this.CheckGSTCNO(item.Number, "after")) {
  //           return false;
  //         }
  //       }
  //     }

  //     const { FileNameObj, NumberObj, IsForLifeTimeObj, ValidityObj, ...filteredItem } = item;
  //     return filteredItem;
  //   }).filter(item => item !== null);

  //   if (filteredData.length === 0) {
  //     console.log("No data to save:", filteredData);
  //     return;
  //   }

  //   this._appService
  //     .Post("Company", "SaveRegistration", filteredData)
  //     .subscribe(
  //       (response) => {
  //         this.toastr.success(
  //           "Registration data saved Successfully !",
  //           "Success"
  //         );
  //         //added by vithujan 26-12-2022
  //         this.GetRegister();
  //       },
  //       (err) => {
  //         this.toastr.error(
  //           "Error occurred while saving Registration Data !",
  //           "error"
  //         );
  //       }
  //     );
  // }

  // saveRegistrationData(): boolean {
  //   
  //   let taxPreference = '';
  //   if (this.OtherDetails && this.OtherDetails.TaxPreference) {
  //     taxPreference = this.OtherDetails.TaxPreference;
  //     console.log('Tax Preference :', taxPreference);
  //   }
  //   //added by BURHAN - 29-April-2026
    
  //   let isUnRegistered = false;//added by BURHAN
  //   if (this.OtherDetails && this.OtherDetails.isUnRegistered !== undefined) {
  //     isUnRegistered = this.OtherDetails.isUnRegistered;
  //     console.log('isUnRegistered Preference :', isUnRegistered);
  //   }
  //   //ended by BURHAN - 29-April-2026

  //   // const gst1Item = this.registerarray.find(
  //   //   item => taxPreference === 'Taxable' && item.Label === 'GST1 (15 digit)'
  //   // );

  //   const gst1Item = this.registerarray.find(
  //     item => item.Label === 'GST1 (15 digit)'
  //   );

  //   if (gst1Item && gst1Item.Number && gst1Item.Number.trim() !== '') {
  //     if (!this.CheckGSTCNO(gst1Item.Number, "after")) {
  //       return false;
  //     }
  //   }

  //   // if (this.isGST1Mandatory) {
  //   //   if (!gst1Item || !gst1Item.Number || gst1Item.Number.trim() === '') {
  //   //     this.toastr.error("GST1 (15 digit) number is Required!", "Error");
  //   //     return false;
  //   //   }
  //   // }

  //   // if (gst1Item) {
  //   //   if (!gst1Item.Number || gst1Item.Number.trim() === '') {
  //   //     this.toastr.error("GST1 (15 digit) number is required!", "Error");
  //   //     return false; 
  //   //   }
  
  //   //   if (!this.CheckGSTCNO(gst1Item.Number, "after")) {
  //   //     return false; 
  //   //   }
  //   // }

  //   // if (gst1Item && (!gst1Item.Number || gst1Item.Number.trim() === '')) {
  //   //   this.toastr.error("GST1 (15 digit) number is required!", "Error");
  //   //   return false; 
  //   // }
  
  //   //this.saveTaxData.emit();//added by BURHAN - 29-April-2026
  //   const filteredData = this.registerarray.map(item => {
  //     item.IsNetworkCompany = true;
  
  //     const { FileNameObj, NumberObj, IsForLifeTimeObj, ValidityObj, ...filteredItem } = item;
  //     return filteredItem;
  //   }).filter(item => item!== null);//.filter one added by bURHAN - 29-April-2026
  
  //   if (filteredData.length === 0) {
  //     console.log("No data to save:", filteredData);
  //     return true;
  //   }
  
  //   this._appService
  //     .Post("Company", "SaveRegistration", filteredData)
  //     .subscribe(
  //       (response) => {
  //         this.toastr.success("Registration data saved Successfully !", "Success");
  //         this.GetRegister();
  //       },
  //       (err) => {
  //         this.toastr.error("Error occurred while saving Registration Data !", "error");
  //       }
  //     );

  //     return true;
  // }
  

  GetTaxPreference() {
    this._appService.GetById("Company", "GetTaxDataList", this.networkId).subscribe((response) => {
      this.ExportType = response[0].TaxPreference;
    },
      (error) => {
        console.log("Error while Getting Register", error);
      })
  }

  CheckGSTCNO(ctrl, ValidationPosition) {
    if (this.OtherDetails.TaxPreference == 'Taxable' && this.OtherDetails.ExemptionReasonText == 'SAMPLE') {
      return true;
    } else {
      const validGSTNO = 'Invalid GST No.';
      var regex = /^([0-9]){2}([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}([0-9]){1}([a-zA-Z]){1}([0-9a-zA-Z]){1}?$/;
      if (regex.test(ctrl) == true || ctrl == undefined) {
        return true;
      }
      else {
        this.toastr.error("GST1 (15 digit) number is Invalid!", "Error");
        return false;
      }
    }
  }

  GetRegistrationData() {

    if (!this.country) {
      return;
    }

    this._appService
      .GetByTwoId(
        "Lookup",
        "GetCompanyRegistrationsByCountry",
        null,
        this.country
      )
      .subscribe(

        (response: any) => {

          if (
            response &&
            Array.isArray(response)
          ) {

            // SIRF ACTIVE DOCUMENTS
            const activeDocuments =
              response.filter(
                x => x.IsActive === true
              );

            // EXISTING SAVED DOCS
            const existingDocuments =
              [...this.registerarray];

            // RESET
            this.registerarray = [];

            activeDocuments.forEach((template) => {

              // AGAR ALREADY SAVE HAI
              const existingDoc =
                existingDocuments.find(
                  x =>
                    x.DocumentId ===
                    template.DocumentTypeId
                );

              // EXISTING DOC USE KARO
              if (existingDoc) {

                this.registerarray.push(
                  existingDoc
                );

              }

              // NAYA BLANK DOC BANAO
              else {

                this.registerarray.push({

                  Label:
                    template.DocumentName,

                  DocumentId:
                    template.DocumentTypeId,

                  Description:
                    template.Description,

                  Number: '',

                  Validity: null,

                  CompanyId:
                    this.networkId,

                  IsForLifeTime: false,

                  DocumentPath: '.',

                  FileName: null,

                  FileExtension: null,

                  FileNameObj: {
                    Label: "File Name",
                    dataField: "FileName",
                    formControlName: "FileName",
                    documentpath: '.',
                    filepath: '',
                    filename: '',
                  },

                  NumberObj: {
                    Label: "Number",
                    dataField: "Number",
                    formControlName: "Number",
                    placeholder:
                      "Enter number",
                  },

                  IsForLifeTimeObj: {
                    lable: "Is Default",
                    dataField:
                      "IsForLifeTime",
                  },

                  ValidityObj: {
                    placeholder:
                      "Select date",
                    dataField:
                      "Validity",
                    formControlName:
                      "Validity",
                    isReadOnly:
                      this.isdatedisable,
                  },

                });

              }

            });

          }

        },

        (err) => {

          this.toastr.error(
            "Error occurred while getting registration data !",
            "error"
          );

        }

      );

  }

  // GetRegistrationData() {
  //   console.log('Country Data : ', this.country);
  //   if (this.country != null) {
  //     this._appService
  //       .GetByTwoId(
  //         "Common",
  //         "GetLookByCategoryNameAndParent",
  //         "RegistrationDocuments",
  //         this.country
  //       )
  //       .subscribe(
  //         (response) => {
  //           if (response && Array.isArray(response) && response.length > 0) {

  //             response.forEach((template) => {
  //               const alreadyExists = this.registerarray.find(x => x.Label === template.Label);
  //               if (!alreadyExists) {
  //                 this.registerarray.push({
  //                   Label: template.Label,
  //                   DocumentId: template.Id,
  //                   Description: template.Description,
  //                   Number: '',
  //                   Validity: null,
  //                   CompanyId: this.networkId,
  //                   IsForLifeTime: false,
  //                   DocumentPath: '.',
  //                   FileName: null,
  //                   FileExtension: null,
  //                   FileNameObj: {
  //                     Label: "File Name",
  //                     dataField: "FileName",
  //                     formControlName: "FileName",
  //                     documentpath: '.',
  //                     filepath: '',
  //                     filename: '',
  //                   },
  //                   NumberObj: {
  //                     Label: "Number",
  //                     dataField: "Number",
  //                     formControlName: "Number",
  //                     placeholder: "Enter number",
  //                   },
  //                   IsForLifeTimeObj: {
  //                     lable: "Is Default",
  //                     dataField: "IsForLifeTime",
  //                   },
  //                   ValidityObj: {
  //                     placeholder: "Select date",
  //                     dataField: "Validity",
  //                     formControlName: "Validity",
  //                     isReadOnly: this.isdatedisable,
  //                   },
  //                 });
  //               }
  //             });

  //           }
  //           console.log('inside GetLookByCategoryNameAndParent', this.registerarray);
  //         },
  //         (err) => {
  //           this.toastr.error("Error occurred while getting registration data !", "error");
  //         }
  //       );
  //   }
  // }
  get isGST1Mandatory(): boolean {
    const taxPref = this.OtherDetails.TaxPreference;
    const unregistered = this.OtherDetails.isUnRegistered === true;
    return taxPref === 'Taxable' && !unregistered;
  }
  //added by BURHAN - 5-May-2026
  saveGST1Only(): boolean {
  const gst1Number = this.OtherDetails.GST1Number;

  if (!gst1Number || gst1Number.trim() === '') {
    this.toastr.error("GST1 (15 digit) number is required!", "Error");
    return false;
  }

  if (!this.CheckGSTCNO(gst1Number, "after")) {
    return false;
  }

  const payload = {
    CompanyId: this.networkId,
    GST1Number: gst1Number.trim(),
    UserId: this.UserId
  };

  Helpers.setLoading(true);
  this._appService.SetGST1ForCompany(payload).subscribe(
    (response) => {
      Helpers.setLoading(false);
      this.toastr.success("GST1 saved successfully!", "Success");
      this.GetRegister(); // Refresh list
    },
    (err) => {
      Helpers.setLoading(false);
      this.toastr.error(err.error || "Error occurred while saving GST1!", "Error");
    }
  );

  return true;
}
}
